import axios from "axios";
import Config from "src/config";

const v2_actionCalendarios = (clienteId,) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/calendarios`
    });
};
export default v2_actionCalendarios;
